// https://forum.ionicframework.com/t/how-to-determine-if-browser-or-app/89149/31
export const IS_APP: boolean = window.location.port === "8100";
